// Vendors
import styled, { css } from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';

const LayoutComponentStyled = styled.div<{ compactView: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_300};
  margin-top: ${({ theme }) => theme.spacing_300};
  text-align: left;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    align-items: stretch;
    margin: 0;
    ${({ compactView }) => (compactView ? 'gap: 0;' : '')}
  }
`;
LayoutComponentStyled.displayName = 'LayoutComponentStyled';

const LayoutFetchingComponentStyled = styled.div<{ fetching: boolean }>`
  ${({ fetching }) =>
    fetching &&
    css`
      margin-top: calc(${({ theme }) => theme.spacing_400} + ${({ theme }) => theme.spacing_300});

      ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
        margin-top: ${({ theme }) => theme.spacing_300};
      }
    `};
`;
LayoutFetchingComponentStyled.displayName = 'LayoutFetchingComponentStyled';

export { LayoutComponentStyled, LayoutFetchingComponentStyled };
